resourcePaths = '{"rootPath":"","assetsPath":""}';function _Input() {
  // Base Class

  this.extends = [_ComponentDataBind];
  this.error = "";
  this.tagName = null;
  this.tagType = null;
  this.fieldErrorNode = null;
  this.isPhone = false;
  this._state = 0;

  this.init = function() {
    this._super();
    if (this.containerDiv == null) {
      console.error("container is null: call this._super() after container is constructed");
      return;
    }

    this.tagName = this.node.tagName.toLowerCase();
    if (this.tagName == "input") {
      this.tagType = this.node.type;
    }

    if (this.declaredClass == "Radio" || this.declaredClass == "Checkbox") {
      return;
    }

    // Construct error container
    if ($(this.node).parents(".phone").length > 0) {
      this.isPhone = true;
      var phoneContainer = $(this.node).parents(".phone")[0];

      if ($(".fieldError", phoneContainer).length > 0) {
        this.fieldErrorNode = $(".fieldError", phoneContainer)[0];

      } else {
        this.fieldErrorNode = $("<div class='fieldError'>" + this._getDefaultErrorMessage() + "<span class='arrow'></span></div>");

        if ($("> label", phoneContainer).length > 0) {
          $(this.fieldErrorNode).insertAfter($("> label", phoneContainer)[0]);

        } else {
          $(this.fieldErrorNode).prependTo(phoneContainer);
        }
      }

    } else {
      this.fieldErrorNode = $("<div class='fieldError'>" + this._getDefaultErrorMessage() + "<span class='arrow'></span></div>")[0];

      if (this.placeholderNode) {
        $(this.fieldErrorNode).insertAfter(this.placeholderNode);

      } else {
        $(this.fieldErrorNode).prependTo(this.containerDiv);
      }
    }
  };

  this.initAllReady = function() { this._super(); };
    this.destroy = function() { this._super(); };

  this.showError = function() {
    this._state = -1;

    if (this.tagType == "radio" || this.tagType == "checkbox") {
      $(this.containerDiv).addClass("error");
      return;
    }

    if (this.isPhone) {
      if ($(this.node).data("mogo-ui-error") != null) {
        $(this.fieldErrorNode).html($(this.node).data("mogo-ui-error") + "<span class='arrow'></span></div>");
      }
    }

    this._onErrorResize();
    /*if (this.declaredClass != "TextField" && this.declaredClass != "TextArea") {
     $(this.fieldErrorNode).fadeIn(250).css("display", "inline-block");
     }*/
    $(this.node).addClass("error");
    $(this.containerDiv).addClass("error");

    if (this.declaredClass == "BooleanGroup" || (this.declaredClass == "Collection" && this.allowGroupErrorMessage)) {
      for (var i = 0; i < this.groupElements.length; i++) {
        $(this.groupElements[i]).mogo().showError();
      }
    }
  };

  this.hideError = function() {
    this._state = 0;

    if (this.tagType == "radio" || this.tagType == "checkbox") {
      $(this.containerDiv).removeClass("error");
      return;
    }

    $(this.fieldErrorNode).fadeOut(250);
    $(this.node).removeClass("error");
    $(this.containerDiv).removeClass("error");

    if (this.declaredClass == "BooleanGroup" || (this.declaredClass == "Collection" && this.allowGroupErrorMessage)) {
      for (var i = 0; i < this.groupElements.length; i++) {
        $(this.groupElements[i]).mogo().hideError();
      }
    }
  };

  this.showErrorLabel = function (overwrite, errorText) {
    if (this._state != -1) {
      this._onErrorResize();
      this.showError();
    }

    // Setup error label
    this.setError(overwrite, errorText);

    if (this.fieldErrorNode) {
      this._onErrorResize();
      $(this.fieldErrorNode).fadeIn(250).css("display", "inline-block");

    } else if (this.groupInstance) {
      this._onErrorResize();
      this.groupInstance.showErrorLabel();
    }
  };

  this.hideErrorLabel = function() {
    if (this._state == -1) {
      if (this.fieldErrorNode) {
        $(this.fieldErrorNode).fadeOut(250);

      } else if (this.groupInstance) {
        this.groupInstance.hideErrorLabel();
      }
    }
  };

  this.setError = function(overwrite, errorText) {
    if (overwrite == true && errorText != null) {
      $(this.fieldErrorNode).html(errorText + "<span class='arrow'></span>");
    } else if (overwrite == true && errorText == null) {
      $(this.fieldErrorNode).html(this.error + "<span class='arrow'></span>");
    }

    this._onErrorResize();
  };

  this.setErrorOnKeyword = function (keyword) {
    if (keyword && typeof this.error != 'string') {
      var msg = this.error[keyword];
      if (msg) {
        this.setError(true, msg);
      } else {
        this.setError(true, this.error['default']);
      }
    } else {
      this.setError(true);
    }
  };

  this.setDisabled = function(boolean) {
    if(boolean) {
      this.disabled = true;
      $(this.node).attr('disabled', 'disabled');
      $(this.containerDiv).addClass('disabled');
      $(this.node).attr('tabindex', '-1');

      if (this.hasOwnProperty('selectorNode')) {
        this.selectorNode.attr('tabindex', '-1');
      }

    } else {
      this.disabled = false;
      $(this.node).removeAttr('disabled');
      $(this.containerDiv).removeClass('disabled');
      $(this.node).removeAttr('tabindex');

      if (this.hasOwnProperty('selectorNode')) {
        this.selectorNode.removeAttr('tabindex');
      }
    }
  };

  this.setReadOnly = function(boolean) {
    if(boolean) {
      this.disabled = true;
      $(this.node).attr('readonly', 'true');
      $(this.containerDiv).addClass('readonly');
      $(this.containerDiv).addClass('disabled');
      $(this.node).attr('tabindex', '-1');

      if (this.hasOwnProperty('selectorNode')) {
        this.selectorNode.attr('tabindex', '-1');
      }

    } else {
      this.disabled = false;
      $(this.node).removeAttr('readonly');
      $(this.containerDiv).removeClass('readonly');
      $(this.containerDiv).removeClass('disabled');
      $(this.node).removeAttr('tabindex');

      if (this.hasOwnProperty('selectorNode')) {
        this.selectorNode.removeAttr('tabindex');
      }
    }
  };

  this._getDefaultErrorMessage = function () {
    return (typeof this.error == 'string') ? this.error : this.error['default'];
  };

  this._onErrorResize = function() {
    var errorHeight = $(this.fieldErrorNode).outerHeight();
    if (this.placeholderNode != null) {
      if (this.placeholderOutside != null && this.placeholderOutside)
        errorHeight = errorHeight - $(this.placeholderNode).outerHeight();
    }

    $(this.fieldErrorNode).css("top", -errorHeight + "px");
  };

}
